/*
 * Module for the Retirement Date Step of the MemberDirect Retirement Application wizard
*/
rs.module("content/benefits/retirementapplication/retirementdatestep",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var separationDate = stepContainer.js(jsSelectors.separationDate);
            var benefitEffectiveDate = stepContainer.js(jsSelectors.benefitEffectiveDate);

            // When we change the separation date, we may need to update the benefit effective date 
            separationDate.change(_handleSeparationDateChange);

            // Update benefit effective date when separation date is changed
            function _handleSeparationDateChange() {
                try {
                    var newDate = new Date($(separationDate).val());
                    var newEffectiveDate = new Date(
                        Date.UTC(
                            newDate.getUTCFullYear(),
                            newDate.getUTCMonth() + 1,
                            1,
                            newDate.getUTCHours(),
                            newDate.getUTCMinutes()
                        )
                    );
                    benefitEffectiveDate.val(new Date(newEffectiveDate).toISODateString());
                }
                catch { }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);